import {workplaceTypes} from "@/types";
import { checkMessage } from "@/utils.js";
import packageJson from '../../../package.json' assert { type: 'json' };
import { setCurrentDateTime } from '@/utils.js';
import { storage } from "@/components/Storage";
import { user } from "@/components/User";
import { interval } from '@/components/Interval.js';
import { loader } from '@/components/Loader.js';
import { server } from '@/components/Server.js';

export const LoginPage = {
    controller: function() {
        var self = this;

        if (user.exists()) {
            m.route('/');
            return;
        }

        this.showPasswordExpiryModal = false;
        this.passwordExpiryData = null;
        this.passwordExpiryDays = 0;

        this.handleSuccessfulLogin = function(response) {
            user.save(response.user);
            storage.config = response.config;
            setCurrentDateTime(response.currentTime);

            const config = storage.config;
            let userSkills = user.get('skills') ? user.get('skills').match(/\d+/g).map(Number) : [];
            const skillsFuelTab = config.SkillsFuelTab ? config.SkillsFuelTab.match(/\d+/g).map(Number) : [];
            const showFuelBlock = userSkills.filter(x => skillsFuelTab.includes(x)).length !== 0;
            user.set('showFuelBlock', showFuelBlock);

            storage.removeItem("messages");
            if(config) {
                if(config["message_service"] !== 'undefined' && config["message_turn"]) {
                    const msgTimerID = storage.getItem("msgTimerID");
                    if(msgTimerID == null) {
                        checkMessage(config["message_service"]);
                        const idTimer = setInterval(() => checkMessage(config["message_service"]), 10000);
                        storage.setItem("msgTimerID", idTimer);
                    }
                    else {
                        clearInterval(msgTimerID);
                        checkMessage(config["message_service"]);
                        const idTimer = setInterval(() => checkMessage(config["message_service"]), 10000);
                        storage.setItem("msgTimerID", idTimer);
                    }
                }
            }

            loader.hide();

            // Проверка срока действия пароля AD
            const adUser = response.ad.user;
            const notificationConfig = response.ad?.notification ?? null;
            
            if (adUser && adUser.daysToPasswordExpire && notificationConfig) {
                if (adUser.daysToPasswordExpire <= notificationConfig.notifyDaysBefore) {
                    // Показываем модальное окно с предупреждением
                    self.showPasswordExpiryModal = true;
                    self.passwordExpiryData = notificationConfig;
                    self.passwordExpiryDays = adUser.daysToPasswordExpire;
                    return; // Не продолжаем навигацию, пока пользователь не закроет модалку
                }
            }

            // Продолжаем стандартную навигацию
            self.continueNavigation();
        };

        this.continueNavigation = function() {
            if (!user.has('state.workplace')) {
                m.route('/workplace');
            } else {
                if (user.get('state.workplace') === workplaceTypes.driver) {
                    m.route('/vehicle');
                } else if (user.get('state.workplace') === workplaceTypes.security) {
                    m.route('/security/flights');
                } else {
                    m.route('/');
                }
            }
        };

        this.closeModalAndContinue = function() {
            self.showPasswordExpiryModal = false;
            self.passwordExpiryData = null;
            self.passwordExpiryDays = 0;
            self.continueNavigation();
        };

        this.login = function(e) {
            e.preventDefault();

            self.errmsg = '';
            loader.show();

            var data = {
                login: e.target.login.value,
                password: e.target.password.value,
                w: screen.width,
                h: screen.height
            };

            m.request({
                method: 'POST',
                url: '/api/login',
                data: data
            }).then(function (response) {
                self.handleSuccessfulLogin(response);
            }, function (response) {
                if (response && response.message) {
                    self.errmsg = m(".alert.alert-danger", response.message.split("\n").map(
                        line => m('',line))
                    );
                } else {
                    server.setOffline();
                }
                loader.hide();
            });
        }
    },

    view: function(ctrl) {
        return [
            m("nav.navbar.bg-primary", [
                m(".container", [
                    m(".navbar-header[style='width:100%; display:flex; justify-content:space-between;align-items:center']", [
                        m(".navbar-brand", "АС Кобра"),
                        m("div[style='margin-left:auto']", `v ${packageJson.version}`)
                    ])
                ])
            ]),
            m(".container", [
                ctrl.errmsg,
                m("form", {onsubmit: ctrl.login.bind(ctrl)},
                    [
                        m("div.form-group", [
                            m("input.form-control.input-lg[style='margin-bottom:3px'][type='text'][name='login'][placeholder='Введите табельный номер'][autocomplete='off'][required]"),
                            m("input.form-control.input-lg[type='password'][name='password'][placeholder='Введите пароль'][autocomplete='off'][required]")
                        ]),
                        m("div.form-group", [
                            m("button.btn.btn-info.btn-block.btn-lg[type='submit']", "Войти")
                        ])
                    ]
                )
            ]),

            // Модальное окно с предупреждением об истечении пароля
            ctrl.showPasswordExpiryModal ? m(".modal.fade.in[style='display:block;background:rgba(0,0,0,0.5)']", 
                m(".modal-dialog[style='height:100dvh;display:flex;flex-direction:column;align-items:center;justify-content:center;']",
                    m(".modal-content[style='padding:2rem 1rem;display:flex;flex-direction:column;align-items:center;justify-content:center;background:#ffdddd']",
                        [
                            m("h4.modal-title", "Внимание!"),
                            m(".modal-body",
                                [
                                    m('',`Ваш пароль истекает через ${ctrl.passwordExpiryDays} дней.`),
                                    m('', `Для смены пароля перейдите на портал: `),
                                    m('', m(`a[href="${ctrl.passwordExpiryData.portal}"]`,ctrl.passwordExpiryData.portal)),
                                    m('', `Администратор: ${ctrl.passwordExpiryData.admin}`),
                                    m('', `Контакт: ${ctrl.passwordExpiryData.contact}`)
                                ]
                            ),
                            m(".modal-footer",
                                m("button.btn.btn-primary[type='button']", {
                                    onclick: ctrl.closeModalAndContinue.bind(ctrl)
                                }, "Продолжить")
                            )
                        ]
                    )
                )
            ) : null
        ];
    }
};

export const LogoutPage = {
    controller: function() {
        if (user.exists()) {
            m.request({
                method: 'GET',
                url: '/api/logout'
            }).then(function() {
                user.destroy();
                document.cookie = 'PHPSESSID' + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                interval.clearAll();
                localStorage.removeItem("msgTimerID");
                m.route('/login');
            })
                .catch(function () {
                    localStorage.clear();
                    document.location.href = "/login";
                });
            ;
        }
    }
};